<template>
  <div class="l-learn-whole-talk" v-if="element">
    <!-- 视频讲解 -->
    <LLearnVideo :class="{ 'l-vedio-no': status != 0 && status != 3 && stage !== STAGE_TYPES.isAnswerRecord }"
      ref="LLearnVideo" class="l-learn-whole-talk-vedio" :options="{
        vid: vid,
        autoplay: autoplay,
        canstop: stage === STAGE_TYPES.isAnswerRecord ? false : true,
        hidePlayBtn: stage === STAGE_TYPES.isAnswerRecord,
      }" @ended="onEnded" v-on="$listeners">
      <!-- 当前题目进度 -->
      <LNumber v-if="element.totalCount" :current="currentCount" :total="element.totalCount"
        class="l-topic-progress" :class="{ 'l-topic-progress-bottom': status != 0 && status != 3 }" />
      <!-- 重播 -->
      <div class="l-topic-replay" v-if="stage === STAGE_TYPES.isAnswerRecord">
        <span class="btn-replay" :class="{ disabled: leftReplayCount <= 0 || status == 2 }" @click="onReplay">
          <img src="./images/replay.png" alt />
          重播 X{{ leftReplayCount }}
        </span>
      </div>
    </LLearnVideo>

    <!-- 录音回答 -->
    <div class="lSoundRecording-btn">
      <lRecorder ref="recorder" :disabled="status == 3 || status == 0" :options="recorderOptions" :allow-manual="true"
        @result="onresult" @init="onRecordInit" />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import LLearnVideo from '../l-learn-video'
import lRecorder from '../../components/l-recorder'
import LNumber from '../../components/l-number'
import localKeyLock from '@/utils/localKeyLock'
import { recordStudyPlayData } from '@/utils/record'
const { mapGetters, mapActions } = createNamespacedHelpers('course')

export default {
  components: { LLearnVideo, lRecorder, LNumber },
  data() {
    return {
      STAGE_KEY: 'LISTENSTOTYRY', //储存扩听故事使用的缓存
      STAGE_LAST_KEY: 'LISTENSTOTYRY_LAST_KEY',
      LOCAL_STAGE_KEY: '',
      LOCAL_RECORD_TIME_KEY: '', // 本题作答次数本地KEY
      stage: '', //当前元素的步骤
      STAGE_TYPES: {
        isVideoExplain: 'VIDEO_EXPLAIN', //题干视频播放
        isAnswerRecord: 'ANSWER_RECORD', //录音
        isPlayAnswerVideo: 'ANSWER_VIDEO', //正确答案播放
      },
      audioData: '', //录音数据
      isVideoExplain: false,
      currentTestItem: {}, //当前元素的数据
      status: 0, //0不能点击,1可以录音,2录音中,3录音结束
      duration: 0, //视频的时长和录音需要倒计时时长
      refText: '', //录音需要的答案
      keywords: '', //中心词
      autoplay: true, //视频是否自动播放
      recorderOptions: {}, //录音配置数据
      vid: '',
      playTimer: null,
      playTime: 0, // 进入页面开始播放的播放时长
    }
  },
  computed: {
    leftReplayCount() {
      return this.element ? this.element.attrs.repeatQuestionNum - this.element.repeat : 0
    },
    ...mapGetters(['element']),
    currentCount() {
      return this.element?.datas?.length - this.element?.unansweredList?.length + 1
    }
  },
  watch: {
    stage(to) {
      switch (to) {
        case this.STAGE_TYPES.isVideoExplain:
          this.$set(this, 'status', 0)
          this.autoplay = false
          break
        case this.STAGE_TYPES.isAnswerRecord:
          this.$set(this, 'status', 1)
          break
        case this.STAGE_TYPES.isPlayAnswerVideo: {
          // 第一次回答已经播放过答案，所以后续直接提交，不再播放
          const times = this._getRecordTimes()
          if (times >= 1) {
            this._submit()
            break
          }
          if (this.$refs.LLearnVideo) {
            this.$refs.LLearnVideo.onPlayEnd() //结束之前的播放
          }
          this.$set(this, 'status', 3)
          this.vid = this.currentTestItem.attrs.answerVideoId //设置答案的视频id
          this.autoplay = true //答案视频自动播放
          this.status = 3
          break
        }
      }
    },
    'element.ELEMENT_TYPE'(to) {
      if (to) {
        if (this.currentCount > this.element.totalCount) {
          this._next()
          return
        }
        this.currentTestItem = this.element.unansweredList[0]
        this.vid = this.currentTestItem.attrs.questionVideoId
        if (this.currentTestItem) {
          this.isVideoExplain = true
          this._initStage()
          // 录音参数
          this.recorderOptions.elementType = this.element.type
          this.recorderOptions.text = this.currentTestItem.attrs.answerTxt
          this.recorderOptions.keywords = this.currentTestItem.attrs.keywordTxt
          this.recorderOptions.duration = this.element.attrs.answerRecordTime
          this.recorderOptions.audioFileName = `${this.element.RECORD_ID}-${this.currentTestItem.id}`
        }
      }
    },
  },
  methods: {
    ...mapActions(['STUDY_RESULT', 'STUDY_MEDIA_REPEAT']),
    _getRecordTimes() {
      const v = localStorage.getItem(this.LOCAL_RECORD_TIME_KEY)
      const n = Number(v)
      return Number.isFinite(n) && n > 0 ? n : 0
    },
    _setRecordTimes(times) {
      localStorage.setItem(this.LOCAL_RECORD_TIME_KEY, String(times))
    },
    _clearRecordTimes() {
      localStorage.removeItem(this.LOCAL_RECORD_TIME_KEY)
    },
    _retryCurrentQuestion() {
      // 只重置本题状态，不刷新页面（避免提交记录后刷新直接跳下一题）
      if (this.$refs.LLearnVideo) {
        try {
          this.$refs.LLearnVideo.onPlayEnd() // 结束当前播放（可能是答案视频）
        } catch (e) {
          /* noop */
        }
      }

      // 切回题干视频 + 录音阶段
      this.vid = this.currentTestItem && this.currentTestItem.attrs
        ? this.currentTestItem.attrs.questionVideoId
        : this.vid
      this.autoplay = false
      this._localStage({ stage: this.STAGE_TYPES.isAnswerRecord, audioData: {} })
      this.status = 1

      // 重置录音组件状态（让按钮可重新录音）
      if (this.$refs.recorder && typeof this.$refs.recorder.reset === 'function') {
        this.$refs.recorder.reset()
      }
    },
    onReplay() {
      if (this.leftReplayCount > 0 && this.$refs.recorder.status === 1) {
        this.STUDY_MEDIA_REPEAT({
          elementId: this.element.id
        }).then(() => {
          setTimeout(() => {
            this.$refs.LLearnVideo.onPlay()
            this.status = 0
          }, 200)
        })
      }
    },
    // 录音初始化成功
    onRecordInit() {
      // 提示带耳机，并主动触发开始
      this.$refs.recorder.start()
      this.status = 2
      this._countTime()
    },
    // 录音完成
    onresult(data) {
      this.audioData = data
      if (!this.audioData) {
        this._localStage({
          stage: this.STAGE_TYPES.isVideoExplain,
        })
        this._initStage()
      } else {
        this._localStage({
          stage: this.STAGE_TYPES.isPlayAnswerVideo,
          audioData: data,
        })

        recordStudyPlayData({
          id: this.currentTestItem.id,
          bizType: this.element.type,
          type: 1,
          offset: this.playTime,
        }, this.element.ELEMENT_TYPE)
      }
    },
    //修改子组件的参数
    // onSetStatus(status) {
    //   if (status == 1) {
    //     //视频初始化
    //     this.autoplay = false //视频不能自动播放
    //     this.$refs.LLearnVideo.onPlayEnd() //结束之前的播放
    //   } else if (status == 3) {
    //     //播放答案视频
    //     this.$refs.LLearnVideo.onPlayEnd() //结束之前的播放
    //     this.vid = this.currentTestItem.attrs.answerVideoId //设置答案的视频id
    //     this.autoplay = true //答案视频自动播放
    //   }
    //   this.status = status //设置按钮的当前状态
    // },
    //视频播放完成
    onEnded() {
      if (this.stage === this.STAGE_TYPES.isVideoExplain || this.stage === this.STAGE_TYPES.isAnswerRecord) {
        //题干视频播放完成
        this.status = 1
        this._localStage({ stage: this.STAGE_TYPES.isAnswerRecord })
      } else if (this.stage === this.STAGE_TYPES.isPlayAnswerVideo) {
        //答案视频播放完成;
        this._submit()
      }
    },
    //根据缓存初始化当前元素的学习进度
    _initStage() {
      // 当前学习元素+当前学生记录+当前题目
      const currentValueKey = `${this.STAGE_KEY}_${this.element.RECORD_ID}_${this.currentTestItem.id}`
      this.LOCAL_STAGE_KEY = localKeyLock(this.STAGE_LAST_KEY, currentValueKey)
      this.LOCAL_RECORD_TIME_KEY = `${this.LOCAL_STAGE_KEY}_TIME`
      try {
        const currentRecord = JSON.parse(
          localStorage.getItem(this.LOCAL_STAGE_KEY)
        )
        // 初始化stage数据，什么都没有，则为开始状态
        this.stage =
          currentRecord && currentRecord.stage
            ? currentRecord.stage
            : this.STAGE_TYPES.isVideoExplain
      } catch (error) {
        // 报错，默认什么都没有，则为初始化状态
        this._localStage({ stage: this.STAGE_TYPES.isVideoExplain })
      }
    },
    // 缓存当前学习进度，防止刷新丢失
    _localStage(params) {
      const localData = this._getLocal()
      if (params) {
        this.stage = params.stage
        params.audioData = params.audioData
          ? params.audioData
          : localData
            ? localData.data
            : {}
        localStorage.setItem(this.LOCAL_STAGE_KEY, JSON.stringify(params))
      } else {
        localStorage.removeItem(this.LOCAL_STAGE_KEY)
      }
    },
    _getLocal() {
      try {
        return JSON.parse(localStorage.getItem(this.LOCAL_STAGE_KEY))
      } catch (error) {
        return null
      }
    },
    // 上传记录
    _submit() {
      const localData = this._getLocal()
      this.STUDY_RESULT({
        elementId: this.element.id,
        postData: {
          eleId: this.currentTestItem.id,
          ...localData.audioData,
        },
      })
        .then((res) => {
          const record = res && res.records && res.records[res.records.length - 1]
          const word = record && record.word ? String(record.word).toLowerCase() : ''
          const times = this._getRecordTimes() + 1
          this._setRecordTimes(times)
          // 第一次作答且评价为 poor / average：留在本题重做一次；第二次不管评价如何都进入下一题
          if ((word === 'poor' || word === 'average') && times === 1) {
            this.$lPrompt({
              message: `Try Again!`,
              successTxt: 'OK',
              successFn: () => {
                // 重做：保留作答次数，重置按钮状态
                this._retryCurrentQuestion()
              },
            })
            return
          }

          // 进入下一题：清理本题作答次数与进度
          this._clearRecordTimes()
          this._localStage()
          if (this.currentCount - 1 === this.element.totalCount) {
            this.$emit('next')
          } else {
            location.reload()
          }
        })
        .catch((err) => {
          console.log('扩听故事上传记录：', err.msg || err.message)
        })
    },
    _next() {
      this.$emit('next')
    },
    // 播放计时
    _countTime() {
      this.playTimer = setInterval(() => {
        this.playTime += 1
      }, 1000)
    },
  },
  destroyed() {
    if (this.playTimer) {
      clearInterval(this.playTimer)
    }
  },
}
</script>

<style lang="stylus">
@import './index.styl'
</style>
